"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionKeys = void 0;
const encoding_1 = require("../encoding");
const types_1 = require("./types");
class EncryptionKeys extends types_1.Encrypted {
    constructor(keys, publicKeys) {
        super(keys || []);
        this.publicKeys = publicKeys || [];
    }
    getPublicKey() {
        if (Array.isArray(this.publicKeys) && this.publicKeys.length > 0) {
            return (0, encoding_1.base64ToArray)(this.publicKeys[this.publicKeys.length - 1]);
        }
        return null;
    }
    setPublicKey(publicKey) {
        this.publicKeys.push(publicKey);
    }
    setPublicKeys(publicKeys) {
        this.publicKeys = publicKeys;
    }
}
exports.EncryptionKeys = EncryptionKeys;
//# sourceMappingURL=encryption-keys.js.map